import { Stack } from '@chakra-ui/react';
import { useGetAgent } from './hooks/useGetAgent';
import Loader from './Loader';
import Wrapper from './Wrapper';
import FullAgentConfigGreeting from './FullAgentConfigGreeting';
import FullAgentConfigTrainingGuide from './FullAgentConfigTrainingGuide';
import FullAgentConfigKnowledgeBase from './FullAgentConfigKnowledgeBase';

const FullAgentConfiguration = () => {
    const { data, loading } = useGetAgent();

    if (loading || !data) {
        return <Loader />;
    }

    return (
        <Wrapper title='Configure Your Agent' description='Set the initial greeting and core instructions to define how your AI voice agent interacts with users.'>
            <Stack spacing='6'>
                <FullAgentConfigGreeting greetingData={data.initialMessage} />
                <FullAgentConfigTrainingGuide trainingGuideData={data.trainingGuide} />
                <FullAgentConfigKnowledgeBase />
            </Stack>
        </Wrapper>
    );
};

export default FullAgentConfiguration;
